// Import required libraries
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { v4 } from "uuid";
import { useHistory } from "react-router-dom";

// Import styles
import "./Breadcrumbs.scss";
import sidenavData from "../../../assets/data/sidenavData.json";

// Import Utils
import { splitUrlToBreadcrumbData } from "../../utils/utils";
import { updateSourceInputs } from "../../redux/actions";

function Breadcrumbs(props) {
  const { match, user, user_detail, updateSourceInputs } = props;
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Current_Usecase = URL.split("/").pop();
  let data = splitUrlToBreadcrumbData(match.url);
  const formatted = data.map((item) => ({
    ...item,
    name: item.name
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "),
  }));

  const SideNavData = [
    {
      app_name: "Harbor",
      id: "harbor/home",
      name: "Home",
      materialUiIconName: "assignment",
      materialUiClassName: "material-icons-outlined",
      specialStyling: false,
      component: "AttributeEnrichment",
    },
    ...(user_detail?.user_info?.allowed_sidenav || sidenavData),
  ];

  const [breadcrumbData, setBreadcrumbData] = useState({});

  const clearReduxState = () => {
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const handleNavClick = (e) => {
    e.preventDefault(); // ⛔ stop default <NavLink> navigation
    clearReduxState();
    history.replace(`/harbor/home`);
  };

  useEffect(() => {
    const Response = SideNavData.find((item) => `/${item.id}` === match.path);
    setBreadcrumbData(Response);
  }, []);

  return (
    <div className={`${user.theme} breadcrumb`}>
      <span key={v4()} className="breadcrumb-item-container">
        <>
          <Link
            className="breadcrumb-item disabled-style"
            to={`/harbor/home`}
            onClick={(e) => handleNavClick(e)}
          >
            {breadcrumbData?.app_name || "Harbor"}
          </Link>
          {formatted &&
            formatted.length > 0 &&
            formatted
              .filter(
                (fdata) =>
                  fdata.name !== breadcrumbData?.app_name &&
                  fdata.name !== "Harbor",
              )
              .map((item) => {
                return (
                  <>
                    <span>&nbsp;/&nbsp;</span>
                    <span className="breadcrumb-item active">
                      {item?.name && item?.name === "Us Segment Mapping"
                        ? "US Segment Mapping"
                        : item?.name || ""}
                    </span>
                  </>
                );
              })}
        </>
      </span>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  user_detail: state.user_detail,
});

const mapDispatchToProps = {
  updateSourceInputs,
};

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs);
